import { Link } from "react-router-dom";
import Logo from "../assets/image/logo22.png";
import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import './Navbar.css';

function Navbar() {
  const [nav, setNav] = useState(false);

  const openNav = () => {
    setNav(!nav);
  };

  return (
    <>
      <nav style={{ fontFamily: 'Montserrat' }}>
        {/* Mobile Navbar */}
        <div className={`mobile-navbar ${nav ? "open-nav" : ""}`}>
          <div onClick={openNav} className="mobile-navbar__close">
            <FaTimes />
          </div>
          <ul className="mobile-navbar__links">
            <li><Link onClick={openNav} to="/">Home</Link></li>
            <li><Link onClick={openNav} to="/about">About</Link></li>
            <li><Link onClick={openNav} to="/models">Models</Link></li>
            <li><Link onClick={openNav} to="/testimonials">Testimonials</Link></li>
            <li><Link onClick={openNav} to="/team">Our Team</Link></li>
            <li><Link onClick={openNav} to="/contact">Contact</Link></li>
            <li style={{ marginTop: '20px' }}>
              <Link className="mobile-button" to="https://www.wakaforme.com/booking/driver/login.php">Sign In</Link>
            </li>
            <li>
              <Link className="mobile-button" to="https://www.wakaforme.com/booking/driver/driver.php">Register</Link>
            </li>
          </ul>
        </div>

        {/* Desktop Navbar */}
        <div className="navbar desktop">
          <div className="navbar__img">
            <Link to="/" onClick={() => window.scrollTo(0, 0)}>
              <img src={Logo} alt="logo-img" style={{ width: '200%' }} />
            </Link>
          </div>
          <ul className="navbar__links" style={{ marginTop: '-1%' }}>
            <li><Link className="home-link" to="/">Home</Link></li>
            <li><Link className="about-link" to="/about">About</Link></li>
            <li><Link className="models-link" to="/models">Models</Link></li>
            <li><Link className="testi-link" to="/testimonials">Testimonials</Link></li>
            <li><Link className="team-link" to="/team">Our Team</Link></li>
            <li><Link className="contact-link" to="/contact">Contact</Link></li>
          </ul>
          <div className="navbar__buttons">
            <Link className="navbar__buttons__register" to="https://www.wakaforme.com/booking/driver/login.php" style={{ background: '#FC8B24' }}>
              Sign In
            </Link>
            <Link className="navbar__buttons__register" to="https://www.wakaforme.com/booking/driver/driver.php" style={{ background: '#FC8B24' }}>
              Register
            </Link>
          </div>

          {/* Mobile Hamburger */}
          <div className="mobile-hamb" onClick={openNav}>
            <FaBars />
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
